import Axios from "axios";
import {
    SET_SALE_CUSTOMER_BALANCE_SUMMARY_LIST,
    UNSET_SALE_CUSTOMER_BALANCE_SUMMARY_LIST,
    SET_EDITING_SALE_CUSTOMER_BALANCE_SUMMARY,
    UNSET_EDITING_SALE_CUSTOMER_BALANCE_SUMMARY,
    SET_VIEW_SALE_CUSTOMER_BALANCE_SUMMARY,
    UNSET_VIEW_SALE_CUSTOMER_BALANCE_SUMMARY
} from "@/store/mutation-types";

import { getSaleCustomerBalanceSummary, saleCustomerBalanceSync } from "@/store/api";

const state = {
    getSaleCustomerBalanceSummaryList: [],
    getEditingSaleCustomerBalanceSummary: null,
    getViewingSaleCustomerBalanceSummary: null,
};

const getters = {
    getSaleCustomerBalanceSummaryList(state) {
        return state.getSaleCustomerBalanceSummaryList;
    },
    getEditingSaleCustomerBalanceSummary(state) {
        return state.getEditingSaleCustomerBalanceSummary;
    },
    getViewingSaleCustomerBalanceSummary(state) {
        return state.getViewingSaleCustomerBalanceSummary;
    }
};

const mutations = {
    [SET_SALE_CUSTOMER_BALANCE_SUMMARY_LIST](state, data) {
        state.getSaleCustomerBalanceSummaryList = data;
    },
    [UNSET_SALE_CUSTOMER_BALANCE_SUMMARY_LIST](state) {
        state.getSaleCustomerBalanceSummaryList = [];
    },
    [SET_EDITING_SALE_CUSTOMER_BALANCE_SUMMARY](state, data) {
        state.getEditingSaleCustomerBalanceSummary = data;
    },
    [UNSET_EDITING_SALE_CUSTOMER_BALANCE_SUMMARY](state) {
        state.getEditingSaleCustomerBalanceSummary = null;
    },
    [SET_VIEW_SALE_CUSTOMER_BALANCE_SUMMARY](state, data) {
        state.getViewingSaleCustomerBalanceSummary = data;
    },
    [UNSET_VIEW_SALE_CUSTOMER_BALANCE_SUMMARY](state) {
        state.getViewingSaleCustomerBalanceSummary = null;
    }
};

const actions = {
    saleCustomerBalanceSync({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saleCustomerBalanceSync, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSaleCustomerBalanceSummaryList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSaleCustomerBalanceSummary, { params: data})
                .then(function (response) {
                    commit('SET_SALE_CUSTOMER_BALANCE_SUMMARY_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_SALE_CUSTOMER_BALANCE_SUMMARY_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getSaleCustomerBalanceSummaryById({ commit }, data) {
        const getSaleCustomerBalanceSummaryRecordById = `${getSaleCustomerBalanceSummary}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getSaleCustomerBalanceSummaryRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
